// Copyright (c) 2022 by Move Closer

import { ComputedRef, Data, Ref } from '@vue/composition-api'

import { AbstractImageProps } from '../../abstract/components/Image'
import { onError, onLoad } from '../../abstract/general'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface ImageProps extends AbstractImageProps, Data {}

/**
 * Determines options of `object-fit` for Image atom.
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum ImageFit {
  Contain= 'contain',
  Cover = 'cover'
}

/**
 * Matches ImageFit properties with applicable css class.
 *
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const imageFitOptions: Record<string, string> = {
  [ImageFit.Contain]: '--contain',
  [ImageFit.Cover]: '--cover'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface UseImageProvides extends onLoad<void>, onError<void> {
  /**
   * Fallback image.
   */
  fallbackImage: ComputedRef<string>

  /**
   * Alternative text
   */
  imgAlt: Ref<string>

  /**
   * Object-fit of image
   */
  imgFitClass: ComputedRef<string>

  /**
   * Source of the image
   */
  imgSrc: Ref<string>

  /**
   * Determines whether img is loaded.
   */
  isLoaded: Ref<boolean>

  /**
   * Determines whether image should be lazy loaded.
   */
  shouldBeLazy: ComputedRef<boolean>

  /**
   * Sizes
   */
  sizes: ComputedRef<string> | undefined

  /**
   * Value for the `<img>'s` `[srcset]` attribute.
   */
  _srcset: ComputedRef<string> | undefined

  /**
   * Value for the title attribute
   */
  title?: Ref<string>
}
